import * as Yup from 'yup'

export default Yup.object({
    username: Yup.string().required('Username is required!'),
    name: Yup.string().required('Name is required field'),
    password: Yup.string().min(8, 'Please use 8 or more chars for password').required('Password is required!'),
    passwordConfirm: Yup.string()
        .oneOf([Yup.ref('password'), null], 'Passwords must match!')
});
